/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { PasswordsControllerForgotMutationResponse, PasswordsControllerForgot400 } from "../../models/passwordsController/PasswordsControllerForgot";

function getPasswordsControllerForgotUrl() {
  const res = { method: 'POST', url: `/api/v1/passwords/forgot` as const }  
  return res
}

/**
 * @description Sends a password reset email with a secure link. Always returns 204 regardless of whether the email exists to prevent enumeration.
 * @summary Initiate password reset
 * {@link /api/v1/passwords/forgot}
 */
export async function passwordsControllerForgot(config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<PasswordsControllerForgotMutationResponse, ResponseErrorConfig<PasswordsControllerForgot400>, unknown>({ method : "POST", url : getPasswordsControllerForgotUrl().url.toString(), ... requestConfig })  
  return res.data
}